import { render } from "./equipment-conf.vue?vue&type=template&id=2b7f32b2&ts=true"
import script from "./equipment-conf.vue?vue&type=script&lang=ts"
export * from "./equipment-conf.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__